import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=55456516&scoped=true&"
import script from "./ResourcesList.vue?vue&type=script&lang=ts&"
export * from "./ResourcesList.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&id=55456516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55456516",
  null
  
)

export default component.exports